(function () {
  "use strict";

  var section = document.getElementById("product-reviews");
  if (!section) return;

  var grid = document.getElementById("pr-grid");
  var filterSelect = document.getElementById("pr-filter");
  var sortSelect = document.getElementById("pr-sort");
  var openBtn = document.getElementById("pr-open-form");
  var modal = document.getElementById("pr-modal");
  var closeEls = modal ? modal.querySelectorAll("[data-pr-close]") : [];
  var rateInput = document.getElementById("pr-rate-input");
  var ratingValue = document.getElementById("pr-rating-value");
  var thumbs = section.querySelectorAll("[data-pr-jump]");

  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll(".pr-card")) : [];

  function applyFilterAndSort() {
    var filter = filterSelect ? filterSelect.value : "all";
    var sort = sortSelect ? sortSelect.value : "latest";

    cards.forEach(function (card) {
      var rating = card.getAttribute("data-rating");
      var hasPhoto = card.getAttribute("data-has-photo") === "true";
      var visible = true;

      if (filter === "photo") {
        visible = hasPhoto;
      } else if (filter !== "all") {
        visible = rating === filter;
      }

      card.hidden = !visible;
    });

    var visibleCards = cards.filter(function (c) { return !c.hidden; });

    if (sort === "highest" || sort === "lowest") {
      visibleCards.sort(function (a, b) {
        var ra = parseFloat(a.getAttribute("data-rating")) || 0;
        var rb = parseFloat(b.getAttribute("data-rating")) || 0;
        return sort === "highest" ? rb - ra : ra - rb;
      });
      visibleCards.forEach(function (card) { grid.appendChild(card); });
    } else {
      // "latest": restore original DOM order (theme block order)
      cards.forEach(function (card) {
        if (!card.hidden) grid.appendChild(card);
      });
    }
  }

  if (filterSelect) filterSelect.addEventListener("change", applyFilterAndSort);
  if (sortSelect) sortSelect.addEventListener("change", applyFilterAndSort);

  // Modal open/close
  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = "";
  }
  if (openBtn) openBtn.addEventListener("click", openModal);
  closeEls.forEach(function (el) { el.addEventListener("click", closeModal); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal && !modal.hidden) closeModal();
  });

  // Star rating input inside the write-review form
  if (rateInput && ratingValue) {
    var stars = Array.prototype.slice.call(rateInput.querySelectorAll(".pr-rate-star"));
    stars.forEach(function (star) {
      star.addEventListener("click", function () {
        var val = star.getAttribute("data-value");
        ratingValue.value = val;
        stars.forEach(function (s) {
          s.classList.toggle("is-active", parseInt(s.getAttribute("data-value"), 10) <= parseInt(val, 10));
        });
      });
    });
  }

  // Jump to a photo review from the thumbnail strip
  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var target = thumb.getAttribute("data-pr-jump");
      if (target === "all-photos") {
        if (filterSelect) {
          filterSelect.value = "photo";
          applyFilterAndSort();
        }
        grid.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      var el = document.getElementById(target);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.style.outline = "2px solid var(--pr-star)";
        setTimeout(function () { el.style.outline = ""; }, 1600);
      }
    });
  });

  applyFilterAndSort();
})();